import React from 'react';
import { Box, CoveragePeriods, Hint, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  &:hover {
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
  transition: fill 0.3s;
`;

export interface LimitedPeriods {
  limitedPeriodStart?: string;
  limitedPeriodEnd?: string;
}
interface Props {
  limitedPeriods?: LimitedPeriods[];
  externalDeductibleMet?: string;
  coveragePeriods?: CoveragePeriods[];
}

export const EnrollmentCoverageInfoHint: React.FC<Props> = ({
  limitedPeriods,
  externalDeductibleMet,
  coveragePeriods,
}) => {
  return (
    <Hint
      hintAlign="right"
      hintWidth={184}
      hintElement={<StyledInfoIcon color="iconSecondary" size="16px" />}
    >
      <Box justify="center" data-testid="EnrollmentCoverageInfoHint_content">
        {limitedPeriods && limitedPeriods.length ? (
          <Inscription size="12px" weight={700} margin={{ bottom: 'spacing2' }}>
            Limited periods:
          </Inscription>
        ) : null}
        {limitedPeriods?.map((period) => (
          <Box key={period.limitedPeriodStart} gap="spacing2" direction="row">
            <Inscription
              size="12px"
              weight={500}
              data-testid="EnrollmentCoverageInfoHint_limited-period-start"
            >
              {period.limitedPeriodStart ? `${period.limitedPeriodStart} - ` : ''}
            </Inscription>
            <Inscription size="12px" weight={500} data-testid="EnrollmentCoverageInfoHint_limited-period-end">
              {period.limitedPeriodEnd
                ? period.limitedPeriodEnd
                : coveragePeriods?.[0]?.endDate || 'No deadline'}
            </Inscription>
          </Box>
        ))}
        {externalDeductibleMet ? (
          <Box
            gap="spacing2"
            margin={{ top: limitedPeriods && limitedPeriods.length ? 'spacing8' : undefined }}
          >
            <Inscription size="12px" weight={700}>
              External deductible met:
            </Inscription>
            <Inscription size="12px" weight={500}>
              {externalDeductibleMet}
            </Inscription>
          </Box>
        ) : null}
      </Box>
    </Hint>
  );
};
